import * as React from 'react'
import {memo} from 'react'
import {useIntl} from 'react-intl'
import {FilterUrlParams} from 'modules/search/types'

import {useDeviceLayout} from '@vio/atlas/context/deviceLayout'
import {Box} from '@vio/atlas/helpers/Box'
import {Radio} from '@vio/atlas/Radio'
import {reviewSentimentMessages} from '@vio/core/src/hotel/reviewSentiments'

interface ReviewScoreFilterProps {
  value: string
  onChange: (filters: FilterUrlParams) => void
}

const ReviewScoreFilterComponent: React.FC<ReviewScoreFilterProps> = ({
  value,
  onChange
}) => {
  const {formatMessage} = useIntl()
  const {isMobile} = useDeviceLayout()
  const handleChange = (reviewScore: string) => {
    const value = reviewScore === 'any' ? undefined : reviewScore
    onChange({reviewScore: value})
  }

  const isActiveFilter = (score: string) => {
    if (!value && score === 'any') return true
    return score === value
  }

  return (
    <Box desktopXs={{minWidth: '299px'}}>
      <Radio
        hasTouchArea
        fullWidth
        checked={isActiveFilter('any')}
        name={`reviewScore-any`}
        label={formatMessage({id: 'any', defaultMessage: 'Any'})}
        onChange={() => handleChange('any')}
        labelSize={isMobile ? 'bodyM' : 'bodyS'}
      />
      <Radio
        hasTouchArea
        fullWidth
        checked={isActiveFilter('9')}
        name={`reviewScore-9`}
        label={`${formatMessage(reviewSentimentMessages['superb'])} 9+`}
        onChange={() => handleChange('9')}
        labelSize={isMobile ? 'bodyM' : 'bodyS'}
      />
      <Radio
        hasTouchArea
        fullWidth
        checked={isActiveFilter('8')}
        name={`reviewScore-8`}
        label={`${formatMessage(reviewSentimentMessages['veryGood'])} 8+`}
        onChange={() => handleChange('8')}
        labelSize={isMobile ? 'bodyM' : 'bodyS'}
      />
      <Radio
        hasTouchArea
        fullWidth
        checked={isActiveFilter('7')}
        name={`reviewScore-7`}
        label={`${formatMessage(reviewSentimentMessages['good'])} 7+`}
        onChange={() => handleChange('7')}
        labelSize={isMobile ? 'bodyM' : 'bodyS'}
      />
    </Box>
  )
}

export const ReviewScoreFilter = memo(ReviewScoreFilterComponent)
